//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drafting.js";
import "../no/Builder.js";
import "../Drafting/Drafting.AttributeItemBuilderList.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../Drafting/Drafting.PrimaryContentItemBuilderList.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"ApplyTemplateToAll",1,0],[1,"Attributes",0,"Drafting.AttributeItemBuilderList",0],[0,"DetailID",1,0],[0,"Discipline",1,0],[0,"DrawingStyle",1,0],[1,"ExcludedContent",0,"Assemblies.SelectComponentList",0],[0,"Folder",1,0],[0,"IntroductoryTemplate",1,0],[0,"Name",1,0],[0,"Number",1,0],[1,"PrimaryContent",0,"Drafting.PrimaryContentItemBuilderList",0],[1,"References",0,"SelectNXObjectList",0],[0,"Revision",1,0],[1,"SecondaryContent",0,"Assemblies.SelectComponentList",0]],[[["nSummary"],"GetSummary",{R_:{summary:""}},0,0],[["summary"],"SetSummary",{},1,0],[["objectCreateBuilder"],"SetObjectCreateBuilder",{},1,0]],[]];
SPLM.Drafting.DrawingCreationWizardBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drafting.DrawingCreationWizardBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;